<template>
  <div v-if="geoCodeLoaded">
    <div class="modal is-active">
      <div class="modal-background">
        <div class="modal-card">
          <header class="modal-card-head">
            <div class="modal-card-head__header">
              <span>PLEASE CHECK AND CONFIRM YOUR ADDRESS BELOW</span>
            </div>
          </header>
          <section class="modal-card-body">
            <gmap-map
              :center="mapCoords"
              :zoom="zoom"
              map-type-id="roadmap"
              style="width: 100%; height: 300px;"
              :options=mapOptions
            ><gmap-marker
                  :position="markerPosition"
                  :draggable="true"
                  :clickable="true"
                  @dragend="updateCoords"
              >
              </gmap-marker>
            </gmap-map>
            <div class="buttons-section">
              <Button class="button is-primary product-details-button" @click="confirmAddress()">CONFIRM</Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["address"],
  data() {
    return {
      zoom: 18,
      markerPosition: {
        lat: '',
        lng: '',
      },
      mapCoords: {
        lat: '',
        lng: '',
      },
      mapOptions: {
        zoomControl: false,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      },
      geoCodeLoaded: false
    }
  },
  methods: {
    updateCoords(location) {
      this.markerPosition = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    },
    async confirmAddress() {
      this.$store.commit("setCoordsFromMap", this.markerPosition);
      document.querySelector('.product').classList.remove('blur');
      document.querySelector('.cybersmart-footer').classList.remove('blur');
      document.querySelector('.smart-bar').classList.remove('blur');
      if (JSON.stringify(this.mapCoords) !== JSON.stringify(this.markerPosition)) {
        await this.$parent.getProducts();
      }
      this.$parent.showGeoModal = false;
    },
  },
  mounted: async function () {
    let vm = this;
    await this.$gmapApiPromiseLazy();
    // eslint-disable-next-line
    const geocoder = new google.maps.Geocoder();
    try {
      const response =  await geocoder.geocode({ address: vm.address });
      this.mapCoords = {
        lat: response.results[0].geometry.location.lat(),
        lng: response.results[0].geometry.location.lng()
      }
      this.markerPosition = this.mapCoords;
      this.$store.commit("setCoordsFromMap", this.markerPosition);
      this.geoCodeLoaded = true;
    } catch {
      document.querySelector('.product').classList.remove('blur');
      document.querySelector('.cybersmart-footer').classList.remove('blur');
      document.querySelector('.smart-bar').classList.remove('blur');
      this.$parent.showGeoModal = false;
      return;
    }
  },
};
</script>

<style lang="scss">
  .buttons-section {
      margin-top: 15px;
  }
  .modal-card-head {
    &__header {
      width: 100%;
    }
  }
</style>
